import React from 'react';
import {
  AppBar,
  Box,
  Tab,
  Tabs
} from '@mui/material';
import { TabContext } from '@mui/lab'
import { MorphingAPIs } from 'features/morphing/components/MorphingAPIs';
import { CFDAPIs } from 'features/cfd/components/CFDAPIs';
import { OptimizationAPIs } from 'features/optimization/components/OptimizationAPIs';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index } = props;
  return (
    value === index ? (
      <Box
        component="div"
        sx={{
          width: '100%',
          height: '100%',
          minHeight: 0,
          overflowY: 'auto',
          overflowX: 'hidden'
        }}>
        {children}
      </Box>
    ) : null
  );
};

const a11yProps = (index: number) => {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
};

const subtitleContainerSx = {
  position: 'sticky', // Make the entire container sticky
  top: 0, // Stick to the top
  zIndex: 10, // Ensure it appears above other content
  width: '100%',
  flexShrink: 0,
  backgroundColor: '#1e1e1e'
};

export const APIPanel: React.FC = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box component="div" sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', minHeight: 0 }}>

      {/* Sticky container for subtitle and divider */}
      <Box component="div" sx={subtitleContainerSx}>
        <TabContext value={value}>
          <AppBar position="static">
            <Tabs
              value={value}
              onChange={handleChange}
              textColor="inherit"
              variant="fullWidth"
              sx={{
                backgroundColor: '#404040',
                '& .MuiTab-root': {
                  fontSize: '0.7rem'
                }
              }}
            >
              <Tab label="Morphing" {...a11yProps(0)} />
              <Tab label="CFD" {...a11yProps(1)} />
              <Tab label="Optimization" {...a11yProps(2)} />
            </Tabs>
          </AppBar>
        </TabContext >
      </Box>

      {/* Scrollable content below */}
      <Box component="div" sx={{ flex: 1, minHeight: 0 }}>
        <TabPanel value={value} index={0}>
          <MorphingAPIs />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <CFDAPIs />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <OptimizationAPIs />
        </TabPanel>
      </Box>

    </Box >
  );
};
